import {object, string, InferType} from 'yup';
import {ValidationMessage} from '$constants/messages';

export const emailSchema = string()
  .trim()
  .max(350, ValidationMessage.EmailExceedCharacterLimit)
  .email(ValidationMessage.EmailInvalid)
  .required(ValidationMessage.EmailRequired);

export const loginSchema = object({
  email: emailSchema,
  password: string().required(ValidationMessage.PasswordRequired),
});

export type LoginFormData = InferType<typeof loginSchema>;
